import { Typography } from "@commonlibs";
import { OperationTypeSelectorRoot, RadioButtonGroupRoot } from "./OperationTypeSelector.styles";
import { OperationTypeSelectorProps } from "./OperationTypeSelector.types";

export default function OperationTypeSelector({ operations, setOperation }: OperationTypeSelectorProps) {
    function onChangeOperation(value: string) {
        const operation = operations.find((item) => item.value === value);
        setOperation(operation!);
    }

    return (
        <OperationTypeSelectorRoot gap={15}>
            <Typography style={{ overflow: "unset" }} variant="body2Strong">
                Tipo de operación
            </Typography>
            <RadioButtonGroupRoot
                key={operations[0].value}
                onChange={onChangeOperation}
                defaultValue={operations[0].value}
                direction="column"
                options={operations.map((item) => ({ ...item, label: item.name }))}
            />
        </OperationTypeSelectorRoot>
    );
}
